<input nbInput fullWidth i18n-placeholder="@@SearchPlaceholder"
       placeholder="Поиск товара"
       [formControl]="inputFormControl"
       (mousedown)="show()"
       fieldSize="small"
       #autoCompleteInput>

<span class="icon"><a [routerLink]="[]" (click)="onSubmit()"><tui-icon icon="search"/></a></span>

@if (terms?.length) {
  <div class="custom-autocomplete">
    @for (product of terms; track product) {
      <div class="custom-autocomplete__item">
        <div class="auto-item">
          <div class="auto-item__photo" (click)="openModalProduct(product)">
            <div class="photo-table">
              <div class="photo-table__picture cursor-pointer">
                <img [src]="getImageUri(product)" alt=""/>
              </div>
            </div>
          </div>
          <div class="auto-item__title" (click)="openModalProduct(product)">
            <div class="article">{{ product.articul }}</div>
            <span class="title cursor-pointer">{{ product.header }}</span>
          </div>
          @if (!isShowcase) {
            <div class="auto-item__count">
              <app-product-availability [product]="product"/>
            </div>
            <div class="auto-item__price">
              <app-product-price [product]="product"/>
            </div>
            @if (!isSpecification) {
              <app-add-to-cart [product]="product" [catalog]="true"/>
            } @else {
              <app-add-to-specification [product]="product"/>
            }
          }
        </div>
      </div>
    }
  </div>
}
